import {converter, formatHex, wcagContrast} from 'culori'

const toOkLch = converter('oklch')

// Tylko light-modern (shouldPickByContrast): ciemny tekst, gdy jest czytelniejszy o wiecej niz 1,5 (WCAG).
// Srednie tony (#8F98AA, #987E00, #6A8F02, #2383e2) dostaja ciemny tekst, a nasycone
// akcenty o zblizonym kontrascie (primary Lavendy, Grafitu) zostaja przy jasnym
const DARK_TEXT_CONTRAST_ADVANTAGE = 1.5

const DARK_TEXT_LIGHTNESS = 0.1
const LIGHT_TEXT_LIGHTNESS = 0.9
const TEXT_CHROMA = 0.01
const FALLBACK_TEXT_COLOR = '#000000'

// Tekst na kolorowym tle (chip, kafel wydarzenia, naglowek grupy): odcien tla przy jasnosci 0.9.
// shouldPickByContrast (light-modern) - na jasnych tlach odcien przy jasnosci 0.1, zeby tekst nie znikal;
// bez tej flagi (Fiord Night, Dark) zawsze jasny, jak dotad
export function getFontColorByBackgroundColor(backgroundColor: string, shouldPickByContrast = false): string {
  try {
    const lightColorObject = toOkLch(backgroundColor)
    lightColorObject.c = TEXT_CHROMA
    lightColorObject.l = LIGHT_TEXT_LIGHTNESS
    const lightColorHex = formatHex(lightColorObject)
    if (!shouldPickByContrast) {
      return lightColorHex
    }
    const darkColorObject = toOkLch(backgroundColor)
    darkColorObject.c = TEXT_CHROMA
    darkColorObject.l = DARK_TEXT_LIGHTNESS
    const darkColorHex = formatHex(darkColorObject)
    const darkColorContrast = wcagContrast(backgroundColor, darkColorHex)
    const lightColorContrast = wcagContrast(backgroundColor, lightColorHex)
    return darkColorContrast > lightColorContrast + DARK_TEXT_CONTRAST_ADVANTAGE ? darkColorHex : lightColorHex
  } catch (error) {
    return FALLBACK_TEXT_COLOR
  }
}
